import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import React from "react";

interface SheetTitleProps {
  children: React.ReactNode;
  /** Custom className */
  className?: string;
  /**
   * Headline size. Defaults to SMALL (text-lg), the design-system size for
   * sheets. Panels migrated from the legacy Drawer pass X_SMALL (text-base)
   * to keep their existing title size unchanged.
   */
  size?: (typeof HEADLINE_SIZES)[keyof typeof HEADLINE_SIZES];
}

/**
 * SheetTitle - Title component for the sheet header
 */
export function SheetTitle({
  children,
  className = "",
  size = HEADLINE_SIZES.SMALL,
}: SheetTitleProps) {
  return (
    <Headline size={size} color="text-primary" className={className}>
      {children}
    </Headline>
  );
}
